import echarts from 'echarts';

import React from 'react';
import ReactDOM from 'react-dom';
import * as styles from './styles';
import * as charts from './charts';
import * as components from './components';
import Ocean from './infographics/ocean';
import Segments from './infographics/segments';
import Datasets from './infographics/datasets';
import ThinkalikeModel from './infographics/thinkalike_model';
import RoICalculatorV2 from './infographics/roi_calculator_v2';

import westeros from './themes/westeros.json';
import pinpoint from './themes/pinpoint';
import pinpoint1 from './themes/pinpoint1';
import pinpoint2 from './themes/pinpoint2';
import pinpoint3 from './themes/pinpoint3';
import pinpoint4 from './themes/pinpoint4';
import pinpoint5 from './themes/pinpoint5';
import pinpoint6 from './themes/pinpoint6';
import hit from './themes/tags/hit';
import miss from './themes/tags/miss';
import validation from './themes/tags/validation';
import target from './themes/tags/target';
import actuarial from './themes/tags/actuarial';

window.React = React;
window.ReactDOM = ReactDOM;

echarts.registerTheme('westeros', westeros.theme);

echarts.registerTheme('light', pinpoint);
echarts.registerTheme('pinpoint', pinpoint);
echarts.registerTheme('pinpoint1', pinpoint1);
echarts.registerTheme('pinpoint2', pinpoint2);
echarts.registerTheme('pinpoint3', pinpoint3);
echarts.registerTheme('pinpoint4', pinpoint4);
echarts.registerTheme('pinpoint5', pinpoint5);
echarts.registerTheme('pinpoint6', pinpoint6);
echarts.registerTheme('hit', hit);
echarts.registerTheme('cluster', hit);
echarts.registerTheme('miss', miss);
echarts.registerTheme('validation', validation);
echarts.registerTheme('target', target);
echarts.registerTheme('actuarial', actuarial);
echarts.registerTheme('hi freq', actuarial);
echarts.registerTheme('lo freq', actuarial);

export { default as Segment } from './infographics/segment';
export { Ocean, Segments, Datasets, ThinkalikeModel, RoICalculatorV2, styles, charts, components };
